var _ellipse, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 31,
    viewBox: "0 0 20 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 28,
    rx: 6,
    ry: 3,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99991 27.5C9.99808 27.4999 9.98198 27.4989 9.94869 27.4881C9.91212 27.4763 9.86253 27.4554 9.79923 27.4205C9.6712 27.35 9.51151 27.2365 9.3217 27.0736C8.94251 26.7482 8.48675 26.2638 7.98019 25.6469C6.96942 24.4158 5.79632 22.706 4.68052 20.8168C3.5652 18.9284 2.51501 16.8739 1.74527 14.9562C0.970338 13.0256 0.5 11.2826 0.5 10C0.5 4.75329 4.75329 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10C19.5 11.2826 19.0297 13.0256 18.2547 14.9562C17.485 16.8739 16.4348 18.9284 15.3195 20.8168C14.2037 22.706 13.0306 24.4158 12.0198 25.6469C11.5133 26.2638 11.0575 26.7482 10.6783 27.0736C10.4885 27.2365 10.3288 27.35 10.2008 27.4205C10.1375 27.4554 10.0879 27.4763 10.0513 27.4881C10.0159 27.4996 9.99991 27.5 9.99991 27.5ZM9.99991 27.5C10 27.5 10.0001 27.5 10.0001 27.5H10H9.99991Z",
    fill: "black",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 4,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMarker);
export default __webpack_public_path__ + "static/media/defaultMarker.f03c820ca758dcf0a5aecc759ca9f61a.svg";
export { ForwardRef as ReactComponent };